import { BASE_URL } from '../../../shared/consts/variables';

export const login = async (email: string, password: string) => {
    const response = await fetch(`${BASE_URL}/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({email, password}),
    });

    return response.json();
}

